import { Component } from '@angular/core';
import { SpecialisationFormComponent } from '../components/specialisation-form/specialisation-form.component';
import { ActivatedRoute } from '@angular/router';
import { SpecialisationsService } from 'src/app/services/api/hr/specialisations.service';

@Component({
  selector: 'app-specialisation-edit-page',
  imports: [SpecialisationFormComponent],
  templateUrl: './specialisation-edit-page.component.html',
  styleUrl: './specialisation-edit-page.component.scss'
})
export class SpecialisationEditPageComponent {
  employeeSpecialisationId!: number
  employeeSpecialisation?: any;

  constructor(
    private route: ActivatedRoute,
    private specialisationsService: SpecialisationsService,
  ) {
  }

  ngOnInit(): void {
    this.employeeSpecialisationId = Number(this.route.snapshot.paramMap.get('employeeSpecialisationId'));
    if (this.employeeSpecialisationId) {
      this.loadData(this.employeeSpecialisationId);
    }
  }

  loadData(employeeSpecialisationId: any) {
    this.specialisationsService.detail(employeeSpecialisationId).subscribe((response: any) => {
      this.employeeSpecialisation = response.data?.employeeSpecialisation;
    });

  }
}
